import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Operadoras from "@/pages/Operadoras";
import DIDs from "@/pages/DIDs";
import IPBXs from "@/pages/IPBXs";
import Rotas from "@/pages/Rotas";
import Anuncios from "@/pages/Anuncios";
import SystemAudios from "@/pages/SystemAudios";
import Recordings from "@/pages/Recordings";
import ACL from "@/pages/ACL";
import CDR from "@/pages/CDR";
import LiveChannels from "@/pages/LiveChannels";
import AntiFraude from "@/pages/AntiFraude";
import FreeSwitch from "@/pages/FreeSwitch";
import Health from "@/pages/Health";
import Backups from "@/pages/Backups";
import Audit from "@/pages/Audit";
import Users from "@/pages/Users";
import CIDAuthorizations from "@/pages/CIDAuthorizations";

function Protected() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-xs font-mono text-[color:var(--text-muted)]"
        data-testid="app-loading">
        Verificando sessão…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Layout />;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/" element={<Protected />}>
              <Route index element={<Dashboard />} />
              <Route path="operadoras" element={<Operadoras />} />
              <Route path="dids" element={<DIDs />} />
              <Route path="ipbxs" element={<IPBXs />} />
              <Route path="clientes-cids" element={<CIDAuthorizations />} />
              <Route path="rotas" element={<Rotas />} />
              <Route path="anuncios" element={<Anuncios />} />
              <Route path="audios-sistema" element={<SystemAudios />} />
              <Route path="gravacoes" element={<Recordings />} />
              <Route path="acl" element={<ACL />} />
              <Route path="cdr" element={<CDR />} />
              <Route path="live" element={<LiveChannels />} />
              <Route path="antifraud" element={<AntiFraude />} />
              <Route path="voxyra-sbc" element={<FreeSwitch />} />
              <Route path="freeswitch" element={<FreeSwitch />} />
              <Route path="health" element={<Health />} />
              <Route path="backups" element={<Backups />} />
              <Route path="audit" element={<Audit />} />
              <Route path="usuarios" element={<Users />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
